import { getLocaleMessages } from 'Src/locale'
import { put } from 'typed-redux-saga'
import { defaultOptions, showNotificationAction, NotifyMessageCreatorOptions } from 'Modules'

export function* notifyMessageCreator(
	messageCode: string,
	messageOptions: NotifyMessageCreatorOptions = defaultOptions
) {
	const { data, options = defaultOptions.options } = messageOptions
	const { notify_messages } = getLocaleMessages('ru')
	const message = data?.length
		? data.reduce((acc, item) => {
				return acc.replace(':data', item || '')
		  }, notify_messages[messageCode])
		: notify_messages[messageCode].replaceAll(':data', '')
	const { type } = options
	yield* put(showNotificationAction({ type, message, ...options }))
}
